import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const HOW_WAS_DAMAGE_ESTIMATED = {
  ON_SITE_VISIT_BY_AN_APPRAISER: 'on_site_visit_by_an_appraiser',
  THROUGH_VIDEO_CALL: 'through_video_call',
  BY_PHONE: 'by_phone',
  THROUGH_WEB_APPLICATION: 'through_web_application',
} as const;

export const HOW_WAS_DAMAGE_ESTIMATED_NAME = 'how_was_damage_estimated';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupHowWasDamageEstimated: FC<Props> = ({
  name = HOW_WAS_DAMAGE_ESTIMATED_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('W jaki sposób oszacowano szkodę?')}</FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-how-was-damage-estimated"
            >
              <RadioItem
                value={HOW_WAS_DAMAGE_ESTIMATED.ON_SITE_VISIT_BY_AN_APPRAISER}
                label={i18n.t('Stacjonarna wizyta rzeczoznawcy')}
                data-testid="radio-item-how-was-damage-estimated-on-site-visit-by-an-appraiser"
              />
              <RadioItem
                value={HOW_WAS_DAMAGE_ESTIMATED.THROUGH_VIDEO_CALL}
                label={i18n.t('Poprzez rozmowę wideo')}
                data-testid="radio-item-how-was-damage-estimated-through-video-call"
              />
              <RadioItem
                value={HOW_WAS_DAMAGE_ESTIMATED.BY_PHONE}
                label={i18n.t('Poprzez rozmowę telefoniczną')}
                data-testid="radio-item-how-was-damage-estimated-by-phone"
              />
              <RadioItem
                value={HOW_WAS_DAMAGE_ESTIMATED.THROUGH_WEB_APPLICATION}
                label={i18n.t('Poprzez aplikację internetową')}
                data-testid="radio-item-how-was-damage-estimated-through-web-application"
              />
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
